import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { InputLanguageDetectionService } from '../input-language-detection-service';
import { NoveltyInputLanguageDetectApi } from '@/infrastructure/api-functions/core-drafting-api/novelty-input-language-detect-api';
import { SupportedLanguages } from '../../constants';
import { ToastError } from '@telecom/shared/utils/toast-error';
import { I18nService } from '@telecom/shared/services/i18n';

@injectable()
export class InputLanguageDetectionServiceImpl implements InputLanguageDetectionService {

    constructor(
        @inject(NoveltyInputLanguageDetectApi)
        private _noveltyInputLanguageDetectApi: NoveltyInputLanguageDetectApi,
        @inject(I18nService)
        private _i18nService: I18nService,
    ) {}

    async detect(input: string): Promise<boolean> {
        const result = await this._detectRepository(input);
        return Promise.resolve(result);
    }

    private async _detectRepository(input: string) {
        const result = await this._noveltyInputLanguageDetectApi.detect({
            input,
        });
        const language = result.toLowerCase();
        if (!SupportedLanguages.includes(language)) {
            const errorMessage = this._i18nService.t('novelty.errors.inputLanguageDetectFailed');
            throw new ToastError(errorMessage);
        }
        return true;
    }
}
